// react-router v8 removed the singleton `browserHistory`. This shim preserves
// the small surface the app used (`push`/`replace`/`goBack`) but backs it with
// the v8 data router's imperative `navigate`. AppRouter registers the router via
// `setRouter` once it's created; calls before that are no-ops (navigation can't
// happen before the router mounts anyway).
type To = string | { pathname?: string; search?: string; hash?: string; query?: any };

interface RouterLike {
  navigate: (to: any, opts?: { replace?: boolean }) => void | Promise<void>;
}

let router: RouterLike | null = null;

export function setRouter(instance: RouterLike): void {
  router = instance;
}

function toPath(to: To): any {
  // v3 callers sometimes pass a location-like object with a `query` map; v8's
  // navigate wants a path string or a partial path with `search`.
  if (to && typeof to === 'object' && 'query' in to && to.query) {
    const search = new URLSearchParams(to.query as Record<string, string>).toString();
    return { pathname: to.pathname, search: search ? `?${search}` : '', hash: to.hash };
  }

  return to;
}

const browserHistory = {
  push(to: To): void {
    if (router) { router.navigate(toPath(to)); }
  },
  replace(to: To): void {
    if (router) { router.navigate(toPath(to), { replace: true }); }
  },
  goBack(): void {
    if (router) { router.navigate(-1 as any); }
  },
};

export default browserHistory;
